// extracted by mini-css-extract-plugin
module.exports = {"cookie-alert":"CookieAlert_cookie-alert__295IS"};